import { MrbBaseRouteStore } from "mrb/core";
import { LoadioArtistService } from "common/services";

class LoadioArtistListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(LoadioArtistService);
    }

    async findLoadioArtists(params) {
        const response = await this.service.find(params);
        return response.data;
    }
}

export default LoadioArtistListRouteStore;
